import React, { useContext } from 'react'
import { FormContext } from '../../FormContext';
import { isFieldSigned,determineIsDisabled } from './utils.js';

const CheckBox = ({ field_id,
    field_column,
    field_label,
    field_disabled,
    field_value, field_mandatory ,field_multiple_type,field_multiple_id,field_disabled_approver}) => {
   
    const { handleChangeInput,  formStatus, formPageType, formApprovalIndex, formUserLock, formMultipleType, formChatPerson, formOfficers } = useContext(FormContext);

    let isSigned = isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type);
    const isDisabled = determineIsDisabled(
        formUserLock,
        formPageType,
        field_multiple_id,
        isSigned,
        field_id,
        formApprovalIndex,
        field_disabled_approver,
        field_disabled,
        formStatus
      );

    return (

        <div className={`form-check  ${field_column? field_column:'col-sm-12'}`} >
            <input className="form-check-input " type="checkbox" name="field_value" disabled={isDisabled}
                checked={field_value}
                onChange={event => handleChangeInput(field_id, event)} />
            <label className="form-check-label"> {field_label} <font color="red">{field_mandatory === 'yes' ? ' *' : ''}</font></label>
        </div>

    )
}

export default CheckBox

